export const cartConstants = {
  ADD_TO_CART_SUCCESS: "USERS_ADD_TO_CART_SUCCESS",
  ADD_TO_CART_FAILURE: "USERS_ADD_TO_CART_FAILURE",

  EMPTY_CART: "EMPTY_CART",
};
